import { Card, Flex, Heading } from "@amzn/storm-ui";
import styled from "styled-components";

export const StyledErrorBoundaryContainer = styled(Flex)`
    height: 100vh;
    text-align: center;
`;

export const StyledErrorBoundaryCard = styled(Card)`
    display: flex;
    flex-direction: column;
    height: max-content;
    padding: 24px;
    width: 50vw;
    max-width: 800px;
    min-width: 600px;
    margin-top: 48px;
    overflow: hidden;
`;

export const StyledErrorBoundaryText = styled(Heading)`
    margin-bottom: 16px;
`;
